import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinStateOutboundConfigsIec104Push',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    connectors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      connectorSelected: {},
      showCalculatorCA: false,
      showCalculatorIOA: false,
      calculatorCA: {
        lowHighBytes: false,
        ca1: 0,
        ca2: 0,
        result: 0
      },
      calculatorIOA: {
        lowHighBytes: false,
        ioa1: 0,
        ioa2: 0,
        ioa3: 0,
        result: 0
      },
      internalValue: this.value
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    types() {
      return [{
        type: 1,
        typeString: 'M_SP_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_SP_NA'),
        timeTag: false
      }, {
        type: 3,
        typeString: 'M_DP_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_DP_NA'),
        timeTag: false
      }, {
        type: 13,
        typeString: 'M_ME_NC',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_ME_NC'),
        timeTag: false
      }, {
        type: 15,
        typeString: 'M_IT_NA',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_IT_NA'),
        timeTag: false
      }, {
        type: 30,
        typeString: 'M_SP_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_SP_TB'),
        timeTag: true
      }, {
        type: 31,
        typeString: 'M_DP_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_DP_TB'),
        timeTag: true
      }, {
        type: 36,
        typeString: 'M_ME_TF',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_ME_TF'),
        timeTag: true
      }, {
        type: 37,
        typeString: 'M_IT_TB',
        descr: this.$i18n_t('NiotaClassic.Consumers.dtypes.M_IT_TB'),
        timeTag: true
      }];
    },
    limitFieldsApplicable() {
      const limitsApplicableToTypes = ['M_ME_NC', 'M_ME_TF'];
      return this.types.filter(t => limitsApplicableToTypes.includes(t.typeString)).map(t => t.type);
    }
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      deep: true
    },
    internalValue: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  methods: {
    showLimitsInput(type) {
      if (!type) {
        return false;
      }
      return this.limitFieldsApplicable.includes(type);
    },
    changeTypeHandler(type) {
      if (!this.limitFieldsApplicable.includes(type)) {
        delete this.internalValue.lowerLimit;
        delete this.internalValue.upperLimit;
      }
    },
    inputAdjust(fieldName, newValue) {
      if (newValue === '') {
        delete this.internalValue[fieldName];
      }
    },
    resetCalculatorCA() {
      this.calculatorCA = {
        lowHighBytes: false,
        ca1: 0,
        ca2: 0,
        result: 0
      };
    },
    resetCalculatorIOA() {
      this.calculatorIOA = {
        lowHighBytes: false,
        ioa1: 0,
        ioa2: 0,
        ioa3: 0,
        result: 0
      };
    },
    handleShowCalculatorCA() {
      this.resetCalculatorCA();
      this.showCalculatorCA = true;
    },
    handleShowCalculatorIOA() {
      this.resetCalculatorIOA();
      this.showCalculatorIOA = true;
    },
    applyCalculatorCA() {
      this.internalValue.ca = this.calculatorCA.result;
      this.showCalculatorCA = false;
      this.internalValue = {
        ...this.internalValue
      };
    },
    applyCalculatorIOA() {
      this.internalValue.ioa = this.calculatorIOA.result;
      this.showCalculatorIOA = false;
      this.internalValue = {
        ...this.internalValue
      };
    },
    calculateAddressCA() {
      let input = [this.calculatorCA.ca1, this.calculatorCA.ca2];
      if (!this.calculatorCA.lowHighBytes) {
        input = [...input].reverse();
      }
      const result = input.map((byte, index) => byte * 256 ** index);
      this.calculatorCA.result = result.reduce((acc, cur) => acc + cur, 0);
    },
    calculateAddressIOA() {
      let input = [this.calculatorIOA.ioa1, this.calculatorIOA.ioa2, this.calculatorIOA.ioa3];
      if (!this.calculatorIOA.lowHighBytes) {
        input = [...input].reverse();
      }
      const result = input.map((byte, index) => byte * 256 ** index);
      this.calculatorIOA.result = result.reduce((acc, cur) => acc + cur, 0);
    }
  }
};